import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import moment from 'moment';
import { WeekService } from '../../providers/weeks.services';
import { FormGroup } from '@angular/forms';
import { KeypressDirective } from '../../directive/keypress-directive';
import { Subscription } from 'rxjs';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Organization } from "../../../common/models/organization";
import { Week } from "../../../common/models/week";
import { AnnualPlanFormWeekComponent } from "../form-week/annual-plan-form-week.component";
import { NgIf } from "@angular/common";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'annual-plan-side-menu-week-edit',
  providers: [],
  styleUrls: ['./side-menu-week-edit.scss'],
  standalone: true,
  imports: [
    AnnualPlanFormWeekComponent,
    NgIf,
    AppDatePipe,
    TranslateModule,
    FlexLayoutModule,
  ],
  templateUrl: './side-menu-week-edit.html'
})
export class AnnualPlanSideMenuWeekEditComponent implements OnChanges, OnDestroy {

    @Input() public organization: Organization = {} as Organization;
    @Input() public annualPlan: AnnualPlan = {} as AnnualPlan;
    @Input() public clickedWeek: Week | undefined;
    @Input() public weeks: Week[] = [];
    @Input() public addRealWeekNumber = false;

    @Output() public weekSelectedEvent: EventEmitter<Week> = new EventEmitter<Week>();
    @Output() public weeksChange = new EventEmitter<Week[]>();
    @Output() public weekToUpdateEvent: EventEmitter<Week> = new EventEmitter<Week>();

    public realWeekNumber: any = null;
    public realWeekYear: any = null;
    public firstDayOfWeek: any = null;
    public lastDayOfWeek: any = null;

    @ViewChild(KeypressDirective, {static: false})
    public keyPressed: KeypressDirective = {} as KeypressDirective;

    private weekForm: FormGroup = {} as FormGroup;

    private disableProTipNavigation = false;
    private subscriptions: Subscription[] = [];

    constructor(
        private weekProvider: WeekService,
    ) {
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (this.clickedWeek) {
            if (this.addRealWeekNumber) {
                const dateStart = moment.utc(this.annualPlan.startedAt).local();
                const nextWeek = dateStart.clone().add(this.clickedWeek.weekNumber! - 1, 'weeks');

                this.realWeekNumber = nextWeek.week();
                this.realWeekYear = nextWeek.weekYear();
                this.firstDayOfWeek = nextWeek.clone().startOf('isoWeek');
                this.lastDayOfWeek = nextWeek.clone().endOf('isoWeek');
            }
        }
    }

    public onPreviousWeekClicked(week: Week) {
        this.subscriptions.push(
            this.weekProvider.findPreviousByWeek(this.organization, this.annualPlan, week.weekNumber!).subscribe((previousWeek: Week) => {
                if (previousWeek) {
                    this.weekSelectedEvent.emit(previousWeek);
                }
            })
        );
    }

    public onNextWeekClicked(week: Week) {
        this.subscriptions.push(
            this.weekProvider.findNextByWeek(this.organization, this.annualPlan, week.weekNumber!).subscribe((nexWeek: Week) => {
                if (nexWeek) {
                    this.weekSelectedEvent.emit(nexWeek);
                }
            })
        );
    }

    public weekUpdated(week: Week) {
        this.weekToUpdateEvent.emit(week);
    }

    public weekFormEvent(formGroup: FormGroup) {
        this.weekForm = formGroup;
    }
}
